import {
  SYSTEM_USER_ID
} from "./chunk-ZGRZS3TV.js";

// src/config-cat/audience.ts
function audienceFromIdentity(identity) {
  const audience = { userId: identity.userId || SYSTEM_USER_ID };
  if (identity.tenantId !== void 0) {
    audience.tenantId = identity.tenantId;
  }
  if (identity.realm !== void 0) {
    audience.realm = identity.realm;
  }
  return audience;
}

export {
  audienceFromIdentity
};
//# sourceMappingURL=chunk-GQVSQN44.js.map